<nav class="horizontal-menu">
  <ul>
    <li *ngFor="let item of items">
      <a (click)="navigateTo(item)" [appPermissionControl]="item.permissionCode">
        <span>{{ item.label }}</span>
        <span *ngIf="item.items" class="pi pi-chevron-down"></span>
      </a>
      <ul *ngIf="item.items" [ngClass]="{'open-left': item.openLeft}">
        <li *ngFor="let child of item.items" (mouseenter)="checkSubmenuPosition($event, child)">
          <a (click)="navigateTo(child)" [appPermissionControl]="child.permissionCode">
            <span>{{ child.label }}</span>
            <span *ngIf="child.items" class="pi pi-chevron-right"></span>
          </a>
          <ul *ngIf="child.items" [ngClass]="{'open-left': child.openLeft}">
            <li *ngFor="let subChild of child.items" (mouseenter)="checkSubmenuPosition($event, subChild)">
              <a (click)="navigateTo(subChild)" [appPermissionControl]="subChild.permissionCode">
                <span>{{ subChild.label }}</span>
              </a>
              <ul *ngIf="subChild.items" [ngClass]="{'open-left': subChild.openLeft}">
                <li *ngFor="let subSubChild of subChild.items">
                  <a (click)="navigateTo(subSubChild)" [appPermissionControl]="subSubChild.permissionCode">
                    <span>{{ subSubChild.label }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>

<div *ngIf="!url" class="card-white mt-2">
    <iframe [src]="defaultUrl" width="100%" height="100%" style="border: none; min-height: 650px;"></iframe>
</div>

<div *ngIf="url" class="card-white mt-2">
    <iframe [src]="url" width="100%" height="100%" style="border: none; min-height: 700px;"></iframe>
</div>